import Vue from "vue";
import App from "./app.vue";
import store from "@/store";
import { i18n } from "@/plugins/i18n";

Vue.config.productionTip = false;

new Vue({
  render: (h) => h(App),
  store,
  i18n,
}).$mount("#banner-bonus");
